var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "117.5%",
    height: "117.6%",
    x: "-8.7%",
    y: "-8.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 17.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 17.5,
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.136011096 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "136.6%",
    height: "136.6%",
    x: "-18.3%",
    y: "-17.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 17.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 17.5,
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowInner",
    result: "shadowInner"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetOuter1",
    in2: "shadowInner",
    operator: "out",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.136011096 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "152.1%",
    height: "152.1%",
    x: "-26%",
    y: "-24%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.136011096 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "d",
    cx: 172,
    cy: 172,
    r: 82
  }), /*#__PURE__*/React.createElement("circle", {
    id: "f",
    cx: 272.5,
    cy: 70,
    r: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 343,
    height: 341,
    x: 0,
    y: 0,
    rx: 91
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00588F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390 0c74 0 122 48 122 122v268c0 74-48 122-122 122H122C48 512 0 464 0 390V122C0 48 48 0 122 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.109 424.701C495.294 478.654 451.679 512 390 512H122C48 512 0 464 0 390V178.551C40.713 166.548 84.663 160 130.5 160c192.126 0 351.081 115.032 377.609 264.701"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85 87)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    stroke: "#FFF",
    strokeWidth: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85 87)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fill: "#000",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    stroke: "#FFF",
    strokeWidth: 35
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85 87)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "#000",
    filter: "url(#e)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    fill: "#FFF"
  })))));
};
export default SvgInstagram;